import { Component, OnInit, Input } from "@angular/core";
import { ServiceControllerService } from "../../../../../services/service-controller/service-controller.service";
import { ToastrService } from "ngx-toastr";
import { BaseError } from "../../../../pages/base-error";
import { Service } from "../../../../../models/service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "service-settings-history",
  templateUrl: "./service-settings-history.component.html",
  providers: [ServiceControllerService, ToastrService],
})
export class ServiceSettingsHistoryComponent extends BaseError implements OnInit {
  public serviceId: string;
  @Input() public service: Service;
  public publishList: any[] = [];

  public page: number = 0;
  public maxPage: number;
  public loading: boolean = false;

  constructor(
    private serviceControllerService: ServiceControllerService,
    public toastr: ToastrService,
    private route: ActivatedRoute,
  ) {
    super(toastr);
  }

  public ngOnInit() {
    if (!this.service?.id || !this.service) {
      this.route.parent.params.subscribe((params) => {
        this.serviceId = (params.serviceId === "new") ? null : params.serviceId;
        if (this.serviceId !== null) {
          this.loadService();
        } else {
          this.service = new Service();
        }
      });
    } else {
      this.serviceId = this.service.id;
      this.loadPublishHistory();
    }
  }

  public loadService() {
    this.serviceControllerService.getService(this.serviceId).subscribe(
      (data: Service) => {
        this.service = data;
        this.loadPublishHistory();
      },
    );
  }

  public loadPublishHistory() {
    this.serviceControllerService.getHistoryPage(this.serviceId, this.page).subscribe(
      (data) => this.responseUpdate(data),
      (error) => this.showErrorMessage(error),
    );
  }

  public getPage(index): void {
    if (!this.loading) {
      this.loading = true;
      this.page = index;
      this.serviceControllerService.getHistoryPage(this.serviceId, this.page).subscribe(
        (data) => this.responseUpdate(data),
        (error) => this.showErrorMessage(error),
        () => this.loading = false,
      );
    }
  }

  public getPages(): any[] {
    const min = this.page - 2 > 0 ? this.page - 2 : 0;
    const max = this.page + 2 <= this.maxPage ? this.page + 2 : (this.page + 1 <= this.maxPage ? this.page + 1 : this.page);
    const pages = [];
    for (let i = min; i <= max; i++) {
      pages.push(i);
    }
    return pages;
  }

  public formatPublisher(publisher) {
    if (publisher !== undefined && publisher !== null) {
      if (publisher.indexOf("(") !== -1) {
        return publisher.slice(0, publisher.indexOf("(") - 1);
      } else {
        return publisher;
      }
    }
  }

  public responseUpdate(data) {
    this.maxPage = data.totalPages - 1;
    this.publishList = data.publishList; // ? data.publishList.filter((h) => !h.ongoingPublishing) : [];
  }

  public showFailReason(publish: any) {
    if (publish.failReason === undefined) { return; }
    if (publish.showReason === undefined) {
      publish.showReason = true;
      return;
    }
    publish.showReason = !publish.showReason;
  }

  public convertMillisecToMinSec(duration: any) {
    if (duration) {
      let seconds: any = Math.floor((duration / 1000) % 60);
      let minutes: any = Math.floor((duration / (1000 * 60)) % 60);
      let hours: any = Math.floor((duration / (1000 * 60 * 60)) % 60);
      hours = (hours < 10) ? "0" + hours : hours;
      minutes = (minutes < 10) ? "0" + minutes : minutes;
      seconds = (seconds < 10) ? "0" + seconds : seconds;
      return (hours > 0 ? hours + ":" : "") + minutes + ":" + seconds;
    } else {
      return null;
    }
  }
}
